import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getExportReportAccountPlatform = async (queries) => {
  const { data } = await SigliveServiceV2({
    method: 'GET',
    url: `/reporting/download/account-platform?${queries}`,
    responseType: 'blob',
  });

  return data;
};

export default getExportReportAccountPlatform;
